<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>schedule</mat-icon> {{isEdit ? 'Stunden bearbeiten' : 'Stunden erfassen'}}
</h2>

<mat-dialog-content class="ze-content">
  <div class="ze-context sk-muted">
    <mat-icon class="sk-inline-icon">assignment</mat-icon> {{data.auftrag.title}}
  </div>

  <div class="ze-offline-hint" *ngIf="canQueue && isOffline">
    <mat-icon>cloud_off</mat-icon>
    <span>Offline – die Stunden werden lokal gespeichert und automatisch nachgesendet.</span>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Person</mat-label>
    <mat-select [(ngModel)]="selectedPersonKey" required>
      <mat-option *ngFor="let o of personOptions" [value]="o.key">{{o.label}}</mat-option>
      <mat-option [value]="freeKey">Andere Person …</mat-option>
    </mat-select>
    <mat-icon matPrefix>person</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width" *ngIf="selectedPersonKey === freeKey">
    <mat-label>Name der Person</mat-label>
    <input matInput [(ngModel)]="freeName" placeholder="Vor- und Nachname">
  </mat-form-field>

  <p class="sk-muted free-hint" *ngIf="selectedPersonKey === freeKey">
    <mat-icon class="sk-inline-icon">info</mat-icon>
    Wird als Arbeiter (ohne Login) im Team gespeichert und ist danach auswählbar.
  </p>

  <div class="form-row">
    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Datum</mat-label>
      <input matInput type="date" [(ngModel)]="workDate" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="hours-field">
      <mat-label>Stunden</mat-label>
      <input matInput type="number" min="0" step="0.25" [(ngModel)]="hours" required>
      <span matSuffix>h</span>
    </mat-form-field>
  </div>

  <div class="sk-filter-chips preset-row">
    <button type="button" class="sk-filter-chip" [class.active]="hours === 4" (click)="hours = 4">4 h</button>
    <button type="button" class="sk-filter-chip" [class.active]="hours === 8" (click)="hours = 8">8 h</button>
    <button type="button" class="sk-filter-chip" [class.active]="hours === 8.5" (click)="hours = 8.5">8,5 h</button>
    <button type="button" class="sk-filter-chip" [class.active]="hours === 10" (click)="hours = 10">10 h</button>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Notiz (optional)</mat-label>
    <textarea matInput [(ngModel)]="note" rows="2" placeholder="z.B. Tätigkeit / Ort"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || !valid">
    <mat-icon *ngIf="!saving">check</mat-icon>
    {{ canQueue && isOffline ? 'Offline speichern' : (isEdit ? 'Speichern' : 'Erfassen') }}
  </button>
</mat-dialog-actions>
